export default "__VITE_ASSET__Cmonfzw$__"